var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommend"},_vm._l((_vm.recommends),function(item){return _c('div',{staticClass:"recommend-item"},[_c('a',{attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.image}}),_c('div',[_vm._v(_vm._s(item.title))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }